import { Form } from "informed";
import styled from "styled-components";

export const FormContainer = styled(Form)`
	height: 100%;
	width: 100%;
	border-radius: 0px, 0px, 12px, 12px;
	border: 1px solid #DED8D8;
	display: flex;
	flex-direction: column;
	background: #FBFBFC;
  min-height: 661px;
`;

export const DivH1 = styled.div`
  height: 20%;
  display: flex;
	margin-left: 40px;
	margin-top: 25px;
	margin-bottom: 28px;
	font-family: Public Sans;
	font-weight: '600';
	justify-content: space-between;
`;

export const DivBtn = styled.div`
	display: flex;
	margin-right: 40px;
	gap: 12px;
  justify-content: start;
`;

export const AddItemBtn = styled.button`
	border-radius: 70px;
	background: #0047B6;
	box-shadow: 2px 2px 7px 0px rgba(0, 0, 0, 0.25);
	height: 30px;
	min-width: 149px;
	padding: 9px 30px;
	display: flex;
	align-items: center;
	justify-content: center;
	border: none;
	span{
		color: #FFF;
		font-family: Public Sans;
		font-size: 16px;
		font-style: normal;
		font-weight: 500;
		line-height: normal;
	}
`;

export const DistributePointsBtn = styled.button`
	border-radius: 70px;
	background: ${props => props.disableDistributeBtn ? '#EFEFEF' : '#CBE4FF'};
	box-shadow: 2px 2px 7px 0px rgba(0, 0, 0, 0.25);
	height: 30px;
	min-width: 149px;
	padding: 9px 30px;
	display: flex;
	align-items: center;
	justify-content: center;
	border: none;
	span{
		color: ${props => props.disableDistributeBtn ? '#D9D9D9' : '#0047B6'};
		font-family: Public Sans;
		font-size: 16px;
		font-style: normal;
		font-weight: 500;
		line-height: normal;
	}
`;

export const SelectOrderBtn = styled.select`
    height: '31px';
    border-radius: '10px';
    border: '1px solid #DED8D8';
    font-family: 'Public Sans';
    font-size: '12px';
    background: '#F7F7F7';
    color: '#383838';
`;

export const AtividadesContainer = styled.div`
  width: 100%;
  max-height: 500px;
  overflow: auto;
`;

export const FiltrosContainer = styled.div`
  width: 100%;
  max-height: 500px;
  padding: 28px 28px 0px 0px;
  overflow: auto;
`;

export const ModalBody = styled.div`
  border-radius: 12px;
  max-height: 807px;
  display: flex;
  justify-content: space-between;
  overflow: hidden;
`;


export const SelectAllContainer = styled.div`
  display: flex;
  height: 44px;
  padding: 12px;
  border-radius: 4px;
  background: #F7F7F7;
  margin-bottom: 7px;
  margin-right: 29px;
`;

export const TextCheckboxStyle = styled.h2`
  color: #333;
  font-family: Public Sans;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;

export const FormSeparator = styled.div`
  border-top: solid #E4E3E3;

  p {
    margin-top: 20px;
    color: #333;
    font-family: Public Sans;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  };
`;


export const StyledCardBg = styled.div`

  .card-form {
    background: #f7f7f7;
    border: 1px solid #bfbfbf;
    height: 800px;

    .card-header {
      background: #f7f7f7;
    }

    .card-body {
      background: #f7f7f7;
      }
  }

  .card-header,
  .card-body {
      background: #f7f7f7;
  }
`;

export const StyledFormItens = styled.div`
  margin-left: 28px;
	margin-top: 28px;
	margin-bottom: 28px;
	font-family: Public Sans;
	font-weight: '600';

  p {
    color: #333;
    font-family: Public Sans;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  }

  label {
    color: #333 !important;
    font-family: Public Sans;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  };
`;

export const StyledCardItens = styled.div`
  margin-left: 28px;
	margin-bottom: 28px;
	font-family: Public Sans;
	font-weight: 600;

  p {
    color: #333;
    font-family: Public Sans;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  }
`;

export const StyledLabelItens = styled.label`
  color: #333;
  font-family: Public Sans;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
`;

export const StyledTitleItens = styled.p`
  color: #333;
  font-family: Public Sans;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  min-width: 280px;
`;

export const RemoveAllBtn = styled.div`
		color: #0047B6;
    font-family: Public Sans;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
`;

export const DivTarget = styled.div`
  display: flex;
  padding: 3px 5px 3px 5px;
  justify-content: start;
  align-items: center;
  margin-left: 4px;
  background: #D0E3F8;
  border-radius: 4px;
  font-size: 12px;
  color: #2466AF;
`;

export const KeyWordsBox = styled.div`
  display: flex;
  gap: 5px;
  height: 101px;
  border-radius: 12px;
  border: 1px solid #CCC;
  background: #F7F7F7;
  align-items: baseline;
  padding-top: 8px;
  flex-wrap: wrap;
`;

export const KeyWordsContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const PKey = styled.p`
  font-size: 14px !important;
  margin-bottom: 1px;
`;

export const InputKeyWord = styled.input`
  height: 34px;
  border-radius: 10px;
  border: 1px solid #DED8D8;
  font-family: 'Public Sans';
  font-size: 12px;
  background-color: #F7F7F7;
  color: #383838;
  width: 100%;
  padding-left: 1rem;
`;

export const InputContainer = styled.div`
  display: flex;
  gap: 12px;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
`;

export const DivContainer = styled.div`
	margin-top: 9px;
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: row;
	align-items: center;
`;

export const DivDrag = styled.div`
	width: 49px;
	height: 40px;
	display: flex;
	flex-direction: row;
	align-items: center;
	border-radius: 12px;
	background: #F7F7F7;
	align-items: center;
	justify-content: center;
	color: #999;
	font-weight: 900;
	margin-left: 40px;
	`;

export const DivAtividade = styled.div`
	width: 100%;
	height: 40px;
	display: flex;
	align-items: center;
	color: #999;
	justify-content: end;
	border-radius: 12px;
	background: #F7F7F7;
	margin-left: 11px;
	margin-right: 40px;
`;

export const DivQuestao = styled.div`
	width: 100%;
	color: #333;
	font-family: Public Sans;
	font-size: 14px;
	font-weight: 500;
	margin-left: 24px;
`;

export const DivInput = styled.div`
	min-width: 124px;
	height: 28px;
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 12px;
	background: #FFF;
	margin-right: 17px;
	font-weight: 500;
	color: #333;
  flex-direction: row;
  text-align: center;

  input {
    width: 45px;
    height: 26px;
    flex-shrink: 0;
    border-radius: 12px;
    background: #FFF;
    border: none;
    -webkit-appearance: none;
    margin: 0;
  }

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`;
